var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 346"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 473",
    width: 51,
    height: 51,
    rx: 5,
    fill: "#3A68D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.3895 39.9094L37.9517 14.8219C38.2326 13.7483 37.2443 12.7698 36.1601 13.0479L28.6452 14.975C27.648 15.2301 27.3068 16.4621 28.0355 17.1837C28.8815 18.0196 29.692 19.0791 30.2484 20.2353C30.7016 21.1769 31.8498 23.5616 30.8242 25.0522C29.7472 26.615 27.3281 25.6312 26.043 26.7435C24.726 27.8857 24.4487 31.138 28.6593 40.1928C28.7251 40.3335 28.8158 40.4638 28.9278 40.573C29.7312 41.3684 31.1051 40.9988 31.3895 39.9094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7981 19.5525C9.73873 19.8429 9.7334 21.3336 10.7856 21.6503C14.0241 22.6236 20.469 24.4081 24.55 24.431C25.707 24.438 28.3802 24.4521 29.0485 23.0847C29.0823 23.016 29.1837 22.7943 29.205 22.4106C29.3134 20.4571 27.0739 18.625 25.6021 17.2857C24.7846 16.5413 23.6416 16.258 22.5664 16.5343L10.8247 19.5455C10.8247 19.5455 10.8087 19.549 10.7998 19.5525H10.7981Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupLogo);
export default __webpack_public_path__ + "static/media/Group-logo.4d7d4ad04cfbc28ab2e3a19dd0aa30b5.svg";
export { ForwardRef as ReactComponent };